
<h1 style="margin-right: 2%; font-weight: bold;">
    {{ currentMonthYear }}
</h1>
<h1>{{ 'menu.'+currentRoute | translate }}</h1>
